import { FilterRow } from "@components/FilterTag/FilterTag";
import { Checkbox } from "@narmi/design_system";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Thread, THREAD_STATES, ThreadQuery } from "../types";
import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { statusToLabel } from "../threadUtil";

export function StatusTag({
  filters,
  expandedTag,
  setExpandedTag,
  setFilters,
}: {
  filters: ThreadQuery;
  expandedTag: string | null;
  setExpandedTag: Dispatch<SetStateAction<string | null>>;
  setFilters: Dispatch<SetStateAction<ThreadQuery>>;
}) {
  const [stateFilters, setStateFilters] = useState<Thread["state"][]>(filters.state);

  useEffect(() => {
    setStateFilters(filters.state);
  }, [expandedTag, filters.state]);

  const { currentUser } = useUserConfiguration();

  return (
    <FilterRow.Tag
      label="Status"
      countApplied={filters.state.length}
      isExpanded={expandedTag === "state"}
      onPopoverDismiss={() => setExpandedTag(null)}
      onToggle={() => setExpandedTag(expandedTag === "state" ? null : "state")}
    >
      <FilterRow.FormContainer>
        {THREAD_STATES.map((state) => (
          <Checkbox
            key={state}
            label={statusToLabel(state, currentUser.support_teams?.length)}
            checked={stateFilters.includes(state)}
            onChange={() => {
              const isChecked = stateFilters.includes(state);
              const newFilters = isChecked
                ? stateFilters.filter((filter) => filter !== state)
                : [...stateFilters, state];

              setStateFilters(newFilters);
            }}
          />
        ))}
      </FilterRow.FormContainer>
      <FilterRow.ActionBar
        onClear={() => {
          setExpandedTag(null);
          setStateFilters([]);
          setFilters((prev) => ({
            ...prev,
            state: [],
            offset: 0,
          }));
        }}
        onApply={() => {
          setExpandedTag(null);
          setFilters((prev) => ({
            ...prev,
            state: stateFilters,
            offset: 0,
          }));
        }}
      />
    </FilterRow.Tag>
  );
}
